/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Time } from './Time';
import {
    TimeFromJSON,
    TimeFromJSONTyped,
    TimeToJSON,
} from './Time';

/**
 * Representation of a Weekday Opening Day
 * @export
 * @interface WeekdayOpeningDay
 */
export interface WeekdayOpeningDay {
    /**
     * 
     * @type {Time}
     * @memberof WeekdayOpeningDay
     */
    openingTime?: Time;
    /**
     * 
     * @type {Time}
     * @memberof WeekdayOpeningDay
     */
    closingTime?: Time;
    /**
     * Text representation of week day opening day
     * @type {string}
     * @memberof WeekdayOpeningDay
     */
    weekDay?: string;
    /**
     * Flag stating if weekday opening day is closed
     * @type {boolean}
     * @memberof WeekdayOpeningDay
     */
    closed?: boolean;
}

/**
 * Check if a given object implements the WeekdayOpeningDay interface.
 */
export function instanceOfWeekdayOpeningDay(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WeekdayOpeningDayFromJSON(json: any): WeekdayOpeningDay {
    return WeekdayOpeningDayFromJSONTyped(json, false);
}

export function WeekdayOpeningDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeekdayOpeningDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'openingTime': !exists(json, 'openingTime') ? undefined : TimeFromJSON(json['openingTime']),
        'closingTime': !exists(json, 'closingTime') ? undefined : TimeFromJSON(json['closingTime']),
        'weekDay': !exists(json, 'weekDay') ? undefined : json['weekDay'],
        'closed': !exists(json, 'closed') ? undefined : json['closed'],
    };
}

export function WeekdayOpeningDayToJSON(value?: WeekdayOpeningDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'openingTime': TimeToJSON(value.openingTime),
        'closingTime': TimeToJSON(value.closingTime),
        'weekDay': value.weekDay,
        'closed': value.closed,
    };
}

